// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {startCase} from 'lodash';

// Components
import Button from '../core/button';
import Form from '../core/form';
import Input from '../core/input';
import Permissions from '../core/permissions';
import Select from '../core/select';
import SubmitButton from '../core/submit-button';
import ScopesTree from './scopes-tree';

// Styles
import './user-form.scss';

function UserForm({ clientId, editing, formName, onReset }) {
  const getFieldProps = (fieldName, type) => ({
    className: type === 'checkbox' ? 'user-form--checkbox' : 'user-form--input',
    label: startCase(fieldName),
    name: fieldName,
    type,
  });

  const handleResetClick = (event) => {
    event && event.preventDefault && event.preventDefault();

    onReset();
  };

  const renderUsername = () => (editing ? (
            <div className="user-form--username">Username: {clientId}</div>
        ) : (
            <Input {...getFieldProps('clientId')} disableAutofill={true} label="Username" validate={['username']} />
        ));

  const formProps = {
    className: 'user-form',
    fixedPositionedResponse: true,
    name: formName,
    resetOnSubmit: formName === 'createUser',
    submitData: true,
    successMessage: !editing
      ? 'Successfully created user. An email will be sent to the user to set their password.'
      : null,
  };

  return (
        <Permissions adminOnly={true} notAuthorizedMessage={true}>
            <Form {...formProps}>
                {renderUsername()}
                <Input {...getFieldProps('name')} disableAutofill={true} label="Full Name" validate={['required']} />
                <Input
                    {...getFieldProps('email')}
                    disableAutofill={true}
                    label="Email"
                    validate={['required', 'email']}
                />
                <Select {...getFieldProps('active')}>
                    <option value="true">true</option>
                    <option value="false">false</option>
                </Select>
                <div className="user-form--checkbox-list">
                    <label className="user-form--label">User Roles (Scope):</label>
                    <ScopesTree className="user-form--scopes-tree" name="scope" validate={['required']} />
                </div>
                <Button
                    {...{
                      onClick: handleResetClick,
                      className: 'user-form--reset',
                    }}
                >
                    Reset
                </Button>
                <SubmitButton label="Save" />
            </Form>
        </Permissions>
  );
}

UserForm.propTypes = {
    clientId: PropTypes.string,
    editing: PropTypes.bool,
    formName: PropTypes.string.isRequired,
    onReset: PropTypes.func,
};

export default UserForm;
